/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GenerationInputsPolymorphic } from './GenerationInputsPolymorphic';
import {
  GenerationInputsPolymorphicFromJSON,
  GenerationInputsPolymorphicFromJSONTyped,
  GenerationInputsPolymorphicToJSON,
} from './GenerationInputsPolymorphic';

/**
 *
 * @export
 * @interface PaginatedGenerationInputsPolymorphicList
 */
export interface PaginatedGenerationInputsPolymorphicList {
  /**
   *
   * @type {number}
   * @memberof PaginatedGenerationInputsPolymorphicList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedGenerationInputsPolymorphicList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedGenerationInputsPolymorphicList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GenerationInputsPolymorphic>}
   * @memberof PaginatedGenerationInputsPolymorphicList
   */
  results: Array<GenerationInputsPolymorphic>;
}

/**
 * Check if a given object implements the PaginatedGenerationInputsPolymorphicList interface.
 */
export function instanceOfPaginatedGenerationInputsPolymorphicList(
  value: object,
): value is PaginatedGenerationInputsPolymorphicList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedGenerationInputsPolymorphicListFromJSON(json: any): PaginatedGenerationInputsPolymorphicList {
  return PaginatedGenerationInputsPolymorphicListFromJSONTyped(json, false);
}

export function PaginatedGenerationInputsPolymorphicListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedGenerationInputsPolymorphicList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(GenerationInputsPolymorphicFromJSON),
  };
}

export function PaginatedGenerationInputsPolymorphicListToJSON(
  value?: PaginatedGenerationInputsPolymorphicList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(GenerationInputsPolymorphicToJSON),
  };
}
